import tick from '@/modules/tick/tick';
import AppConfig from '@/AppConfig';

const PROBLEM_TIMEOUT = AppConfig.serviceProblemTimeout;

class Loader {
  title: string;
  created: Date;
  id: string;
  constructor(title: string) {
    this.title = title;
    this.id = `loader-${Math.random()
      .toString()
      .replace('0.', '')}`;
    this.created = new Date();
  }
}
export default {
  state: {
    loaders: [],
    problem: false
  },
  mutations: {
    'loaders/set'(state: any, loaders: Array<Loader>) {
      state.loaders = loaders;
    },
    'loaders/problem/set'(state: any, isProblem: boolean) {
      state.problem = isProblem;
    }
  },
  actions: {
    'loader/checkForProblems'(context: any) {
      let newest = context.getters['loader/getAge'];
      if (newest) {
        let diff = new Date().getTime() - newest.created.getTime();
        if (diff > PROBLEM_TIMEOUT - 10) {
          context.commit('loaders/problem/set', true);
        } else {
          context.commit('loaders/problem/set', false);
        }
      } else {
        context.commit('loaders/problem/set', false);
      }
    },
    /**
     * Show the Loader
     */
    'loader/start'(context: any, title: string = 'Loading...') {
      // Create a loader obj
      let loader = new Loader(title);
      // Push it to the current loaders
      let loaders = context.state.loaders;
      loaders.push(loader);
      // Set to the state
      context.commit('loaders/set', loaders);
      // Wait 5 seconds to check if things are still loading.
      tick(PROBLEM_TIMEOUT, () => {
        context.dispatch('loader/checkForProblems');
      });
      return () => {
        return context.dispatch('loader/remove', loader);
      };
    },
    /**
     * Remove a loader from loaders
     * The loader will only show when it has some loaders
     */
    async 'loader/remove'(context: any, loader: Loader) {
      let loaders = context.state.loaders.filter((loopLoader: any) => {
        return loopLoader.id != loader.id;
      });

      context.commit('loaders/set', loaders);
      context.dispatch('loader/checkForProblems');
    }
  },
  getters: {
    // Get the oldest Loader in the batch
    'loader/getAge'(state: any): Loader | null {
      if (state.loaders.length) {
        // Get oldest Loader to determin age
        let newest = [...state.loaders].sort((a: any, b: any) => {
          return a.created > b.created ? 1 : -1;
        })[0];
        return newest;
      } else {
        return null;
      }
    }
  }
};
